<div id="login" [ngStyle]="{'background': 'url(' + '/assets/images/backgrounds/' + months[monthIndex] +'.jpg)'}" fxLayout="column" fusePerfectScrollbar>

  <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

    <div id="login-form" *fuseIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

      <div [ngClass]="{'logo-def' : logoUrl === 'assets/images/logos/fuse.svg',
      'logo':  logoUrl !== 'assets/images/logos/fuse.svg'}">
        <img src="{{logoUrl}}">
      </div>

<!--      <div class="title">LOGIN TO YOUR ACCOUNT</div>-->

      <form name="loginForm" [formGroup]="loginForm" novalidate>
        @if (errMsg) {
          <div class="error">
            <div>{{errMsg | translate}}</div>
            @if (errMsg === 'too_many_logins') {
              <div>{{'next_login_available' | translate}} {{nextAvailableLogin}} {{'minutes' | translate}}</div>
            }
          </div>
        }
        <mat-form-field>
          <input matInput placeholder="Email" formControlName="email" autocomplete="email">
          @if (loginFormErrors.email.required) {
            <mat-error>
              E-Mail ist erforderlich
            </mat-error>
          }
          @if (!loginFormErrors.email.required && loginFormErrors.email.email) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <input type="password" matInput placeholder="Password" formControlName="password">
          @if (loginFormErrors.password.required) {
            <mat-error>
              Passwort wird benötigt
            </mat-error>
          }
        </mat-form-field>

        <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
          fxLayoutAlign="space-between center">


          <a class="forgot-password" [routerLink]="'/pages/auth/forgot-password'">
            Passwort vergessen?
          </a>
        </div>

        <button mat-raised-button color="accent" class="submit-button" aria-label="LOG IN"
          [disabled]="loginForm.invalid" (click)="logIn()">
          LOGIN
        </button>

      </form>

    </div>

  </div>

</div>
